import * as React from "react";
import {
  DataGrid,
  GridFooterContainer,
  useGridApiContext,
  useGridSelector,
  gridRowCountSelector,
  gridPageSelector,
  gridPageCountSelector,
} from "@mui/x-data-grid";
import { Button, Pagination } from "@mui/material";
import PropTypes from "prop-types";
import Modal from "./Modal";

const PAGE_SIZE = 10;

function CustomFooter() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);

  const from = rowCount === 0 ? 0 : page * PAGE_SIZE + 1;
  const to = Math.min((page + 1) * PAGE_SIZE, rowCount);
  const totalPages = Math.max(pageCount, 1);

  return (
    <GridFooterContainer>
      <div style={{ padding: "0 16px", fontSize: "13px" }}>
        {`${from}-${to} / ${rowCount}件`}
      </div>
      <Pagination
        count={totalPages}
        page={page + 1}
        onChange={(_, value) => apiRef.current.setPage(value - 1)}
        size="small"
      />
    </GridFooterContainer>
  );
}

export default function MemberGroupDataTable({
  members,
  setTargetMembers,
  filterGroup,
  onDeleteMember,
  loading,
}) {
  const [deleteConfirmModalStatus, setDeleteConfirmModalStatus] = React.useState(false);
  const [pendingDeleteMember, setPendingDeleteMember] = React.useState(null);

  const deleteConfirmModalOpen = (member) => {
    setPendingDeleteMember(member);
    setDeleteConfirmModalStatus(true);
  };
  const deleteConfirmModalClose = () => setDeleteConfirmModalStatus(false);
  const onDeleteConfirmed = () => {
    setDeleteConfirmModalStatus(false);
    onDeleteMember(pendingDeleteMember);
  };

  const columns = [
    //{ field: "UserId", headerName: "ID", width: 70 },
    {
      field: "NickName",
      headerName: "表示名",
      width: 150,
    },
    {
      field: "Furigana",
      headerName: "ふりがな",
      width: 160,
    },
    ...(filterGroup && filterGroup !== "ALL"
      ? [
          {
            field: "deleteAction",
            headerName: "グループから削除",
            width: 160,
            sortable: false,
            renderCell: (params) => (
              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={() => deleteConfirmModalOpen(params.row)}
              >
                削除
              </Button>
            ),
          },
        ]
      : []),
  ];

  const clicked2 = (ids) => {
    const selectedIDs = new Set(ids);
    const selectedRowData = (members || []).filter((row) =>
      selectedIDs.has(row.id.toString())
    );
    setTargetMembers(selectedRowData);
  };

  return (
    <div style={{ width: "100%" }}>
      <Modal
        title={"グループからメンバー除外"}
        message={pendingDeleteMember ? `「${pendingDeleteMember.NickName}」をこのグループから除外しますか？` : ""}
        status={deleteConfirmModalStatus}
        okBtnLabel={"除外"}
        okBtnCallback={onDeleteConfirmed}
        cancelBtnCallback={deleteConfirmModalClose}
      />
      <DataGrid
        rows={members || []}
        loading={loading ?? false}
        columns={columns}
        pageSize={PAGE_SIZE}
        rowsPerPageOptions={[PAGE_SIZE]}
        checkboxSelection={true}
        density="compact"
        autoHeight
        onSelectionModelChange={(ids) => clicked2(ids)}
        components={{ Footer: CustomFooter }}
        initialState={{ sorting: { sortModel: [{ field: "Furigana", sort: "asc" }] } }}
      />
    </div>
  );
}

MemberGroupDataTable.propTypes = {
  members: PropTypes.array,
  setTargetMembers: PropTypes.any,
  filterGroup: PropTypes.any,
  onDeleteMember: PropTypes.func,
  loading: PropTypes.bool,
};
